import { createReducer, createAction, createSelector } from 'redux-starter-kit';

export interface ProjectType {
  audience_age_from: number;
  audience_age_to: number;
  audience_country: string[];
  audience_gender: number;
  audience_group_size: number;
  brand: string;
  calculated_price: {};
  category: number;
  created_at: string;
  discount: {};
  final_price: {};
  id: number;
  name: string;
  research_goal: number;
  segments: {};
  status: { value: number; display: string };
  sub_category: number;
  updated_at: string;
  uuid: string;
  discount_code?: string;
  other_category?: string;
}

// State
export interface ProjectState extends Partial<ProjectType> {
  statistics: {
    completed: string | number;
    screenout: string | number;
    quotafull: string | boolean;
    total: string | number;
    started: string | number;
    untouched: string | number;
  };
}

export const initialState: ProjectState = {
  statistics: {
    completed: 'n/a',
    screenout: 'n/a',
    quotafull: 'n/a',
    total: 'n/a',
    started: 'n/a',
    untouched: 'n/a',
  },
};

// Actions
const SET_PROJECT_STATISTICS = 'project/SET_PROJECT_STATISTICS';
const CLEAR_PROJECT_STATISTICS = 'project/CLEAR_PROJECT_STATISTICS';

const setProjectStatistics = createAction(SET_PROJECT_STATISTICS);
const clearProjectStatistics = createAction(CLEAR_PROJECT_STATISTICS);

export const projectActions = {
  setProjectStatistics,
  clearProjectStatistics,
};

// Selectors
export const projectSelectors = {
  projectStatistics: createSelector(['project.statistics']),
};

// Reducers
export default createReducer(initialState, {
  [SET_PROJECT_STATISTICS]: (state, action) => {
    state.statistics.completed =
      typeof action.payload.completed !== 'undefined'
        ? action.payload.completed
        : 'n/a';
    state.statistics.screenout =
      typeof action.payload.screenout !== 'undefined'
        ? action.payload.screenout
        : 'n/a';
    state.statistics.quotafull =
      typeof action.payload.quotafull !== 'undefined'
        ? action.payload.quotafull
        : 'n/a';
    state.statistics.total =
      typeof action.payload.total !== 'undefined'
        ? action.payload.total
        : 'n/a';
    state.statistics.started =
      typeof action.payload.started !== 'undefined'
        ? action.payload.started
        : 'n/a';
    state.statistics.untouched =
      typeof action.payload.untouched !== 'undefined'
        ? action.payload.untouched
        : 'n/a';
  },
  [CLEAR_PROJECT_STATISTICS]: (state) => {
    state.statistics.completed = initialState.statistics.completed;
    state.statistics.screenout = initialState.statistics.screenout;
    state.statistics.quotafull = initialState.statistics.quotafull;
    state.statistics.total = initialState.statistics.total;
    state.statistics.started = initialState.statistics.started;
    state.statistics.untouched = initialState.statistics.untouched;
  },
});
